<template>
  <div class="about has-background-white-bis fixspace">
    <section class="hero is-white is-medium">
      <div class="hero-body pb-5">
        <div class="container is-max-desktop pb-6">
          <h1 class="title">
            {{ $t('about.about') }}
          </h1>
        </div>
        <div class="container is-max-desktop my-6">
          <p class="is-size-5 py-1">
            {{ $t('about.abouthero1') }}
          </p>
          <p class="is-size-5 py-1">
            {{ $t('about.abouthero2') }}
          </p>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <p class="py-6" style="line-height:30px;">
              {{ $t('about.aboutsec1') }}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <img :src="require('@/assets/heroimage.png')" alt="Musian"
            style="height:auto; width:100%;">
          </div>
        </div>
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <p class="py-6" style="line-height:30px;">
              {{ $t('about.aboutsec2') }}
            </p>
            <p>
              {{ $t('about.aboutsec3') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="aboutlast hero is-small">
      <div class="hero-body py-6 has-text-centered has-text-white">
        <div class="container is-max-desktop my-6">
          <p class="is-size-5 py-1">
            {{ $t('about.aboutcommunity') }}
          </p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  name: 'About',

  metaInfo() {
    return {
      title: this.$t('title.about'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.about') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.about'));
      }, 500);
    },
  },
};
</script>

<style lang="scss">
section.aboutlast {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('https://images.unsplash.com/photo-1509782642997-4befdc4b21c9?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80') no-repeat center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
